import script from "./AdtMtrl.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdtMtrl.vue?vue&type=script&lang=ts&setup=true"

import "./AdtMtrl.vue?vue&type=style&index=0&id=dbfa36a0&lang=scss&scoped=true"
import "./AdtMtrl.vue?vue&type=style&index=1&id=dbfa36a0&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbfa36a0"]])

export default __exports__